import React from 'react';

export interface MenuOptions {
  size?: 'sm' | 'md';
}

export function useMenu({ size = 'sm' }: MenuOptions = {}) {
  return React.useMemo(
    () => ({
      size,
    }),
    [size]
  );
}

type ContextType = ReturnType<typeof useMenu> | null;

export const MenuContext = React.createContext<ContextType>(null);

export const useMenuContext = () => {
  const context = React.useContext(MenuContext);

  if (context == null) {
    throw new Error('Menu components must be wrapped in <VoxelMenuContainer />');
  }

  return context;
};
